import { render, staticRenderFns } from "./NokDetails.vue?vue&type=template&id=7c0b98aa&"
import script from "./NokDetails.vue?vue&type=script&lang=js&"
export * from "./NokDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports